import { getAnalytics } from "@tm/insurance/analytics";
import { TextNodeType } from "@tm/isomorphic-utils";
import React, { useEffect } from "react";
import FormattedText from "../FormattedText/FormattedText";
import { ImageComponent } from "../ImageComponent/ImageComponent";
import { BulletItem } from "../InfoModal/InfoModal.style";
import LandingButton from "../LandingButton/LandingButton";
import { ModalWrapper } from "../ModalWrapper/ModalWrapper";
import {
  BulletIcon,
  BulletList,
  BulletText,
  Description,
  IconContainer,
  ListContainer,
  MainHeading,
  ModalBody,
  ModalHeader,
  PersuasionBox,
  SectionContent,
  SectionLabel,
} from "./CalendarPersuasionModal.style";

interface ListItem {
  icon: string;
  title: TextNodeType;
}
interface CalendarModalData {
  minimumDurationDays: number;
  modal: {
    icon: string;
    heading: string;
    header: TextNodeType;
    subHeader: TextNodeType;
    description: TextNodeType;
    persuasion: TextNodeType;
    primaryCtaText: TextNodeType;
    secondaryCtaText?: TextNodeType;
    list?: ListItem[];
  };
}

interface CalendarPersuasionModalProps {
  data: CalendarModalData;
  isOpen: boolean;
  onClose: () => void;
  onPrimaryCTAClick?: () => void;
  onSecondaryCTAClick?: () => void;
}

export const CalendarPersuasionModal: React.FC<
  CalendarPersuasionModalProps
> = ({ data, isOpen, onClose, onPrimaryCTAClick }) => {
  if (!data) return null;
  const analytics = getAnalytics();
  useEffect(() => {
    analytics?.trackCommonLandingEvents({
      actionType: "calendarPersuasionModal_seen",
    });
  }, []);

  const primaryCtaText =
    typeof data.modal.primaryCtaText?.text === "object" &&
    !Array.isArray(data.modal.primaryCtaText?.text)
      ? data.modal.primaryCtaText?.text?.value
      : "Try ANNUAL PLAN";

  const handlePrimaryClick = () => {
    if (onPrimaryCTAClick) {
      onPrimaryCTAClick();
    } else {
      onClose();
    }
  };

  return (
    <ModalWrapper isOpen={isOpen} onClose={onClose}>
      <ModalHeader>
        <MainHeading>{data.modal.heading}</MainHeading>
        <IconContainer>
          <ImageComponent
            src={data.modal.icon}
            width="100%"
            height="100%"
            alt="Annual Plan"
          />
        </IconContainer>
      </ModalHeader>

      <ModalBody>
        <SectionLabel>
          <FormattedText value={data.modal.header} />
        </SectionLabel>
        <SectionContent>
          <FormattedText value={data.modal.subHeader} />
        </SectionContent>

        <Description>
          <FormattedText value={data.modal.description} />
        </Description>

        <PersuasionBox>
          <FormattedText value={data.modal.persuasion} />
        </PersuasionBox>

        <ListContainer>
          <BulletList>
            {data?.modal?.list?.map((item: ListItem, index: number) => (
              <BulletItem key={index}>
                <BulletIcon />
                <BulletText>
                  <FormattedText value={item.title} />
                </BulletText>
              </BulletItem>
            ))}
          </BulletList>

          <LandingButton
            customTitle={primaryCtaText}
            onClick={() => {
              analytics?.trackCommonLandingEvents({
                actionType: "calendar_annual_multi_trip_primary_cta_clicked",
              });
              handlePrimaryClick();
            }}
            customWidth="100%"
          />
        </ListContainer>
      </ModalBody>
    </ModalWrapper>
  );
};

export default CalendarPersuasionModal;
